exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*\n * Copyright (c) 2016-present, Parse, LLC\n * All rights reserved.\n *\n * This source code is licensed under the license found in the LICENSE file in\n * the root directory of this source tree.\n */\n.entry__2VO {\n  padding: 10px;\n  font-size: 14px;\n  line-height: 1.1;\n  list-style: none; }\n  .entry__2VO.buildLogs__Vha {\n    padding: 2px 10px;\n    font-size: 13px; }\n  .entry__2VO.error__osT .time__2s7 {\n    color: #f62943; }\n  .entry__2VO.info__2Rx .time__2s7 {\n    color: #1bb933; }\n  .entry__2VO.warn__Xc4 .time__2s7 {\n    color: #F6DA28; }\n  .entry__2VO .time__2s7 {\n    display: block;\n    font-style: italic; }\n  .entry__2VO .content__2sZ, .entry__2VO .stack__2tF {\n    white-space: pre-wrap; }\n", ""]);
// Exports
exports.locals = {
	"entry": "entry__2VO",
	"buildLogs": "buildLogs__Vha",
	"error": "error__osT",
	"time": "time__2s7",
	"info": "info__2Rx",
	"warn": "warn__Xc4",
	"content": "content__2sZ",
	"stack": "stack__2tF"
};